import i18n from '@/i18n';
import store from '@/store';
import triggerers from './triggerers';
import validator from 'validator';

const validators = {
  ...triggerers,

  // TODO: Replace the regexes with validator library
  regEx: {
    email: /\S+@\S+\.\S+/,
    password: /(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9]).{6,}/,
    vatNumber: /^[A-Z]{2}[A-Z0-9._-]+$/,
  },

  passwordToMatch: '',

  primitive(
    _rule: unknown,
    value: string | number | boolean | undefined | null,
    callback: (arg0?: Error) => void,
  ): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    callback();
  },

  structural(
    _rule: unknown,
    value: Record<string, unknown> | unknown[],
    callback: (arg0?: Error) => void,
  ): void {
    if (!Object.keys(value).length) {
      callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));
    }

    callback();
  },

  gender(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (value === undefined) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    callback();
  },

  email(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (!validators.regEx.email.test(value)) {
      callback(new Error(i18n.t('pleaseUseAValidEmail') as string));
    }

    callback();
  },

  password(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('pleasePutAPassword') as string));

    if (!validators.regEx.password.test(value)) {
      callback(new Error(i18n.t('pleaseUseAValidPassword') as string));
    }

    validators.passwordToMatch = value;

    callback();
  },

  checkPassword(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (!validators.regEx.password.test(value)) {
      callback(new Error(i18n.t('pleaseUseAValidPassword') as string));
    }

    if (value !== validators.passwordToMatch) {
      callback(new Error(i18n.t('passwordsDoNotMatch') as string));
    }

    callback();
  },

  // TODO: Use the isVAT() function from the validator library when more countries are available
  vatNumber(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (!validators.regEx.vatNumber.test(value)) {
      callback(new Error(i18n.t('pleaseUseAValidVatNumber') as string));
    }

    callback();
  },

  assessmentType(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('specifyAssessmentType') as string));

    callback();
  },

  projectDeadline(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (new Date(value).getTime() < new Date().getTime()) {
      callback(new Error(i18n.t('youCanNotSelectThisDate') as string));
    }

    callback();
  },

  pricePerAssessment(_rule: unknown, value: number, callback: (arg0?: Error) => void): void {
    if (value === undefined) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (value > store.state.meta.maximalPricePerAssessment)
      callback(new Error(i18n.t('numberTooBig') as string));

    if (value < store.state.meta.minimalPricePerAssessment) {
      callback(
        new Error(
          `${i18n.t('priceLowerThan')} ${store.state.meta.minimalPricePerAssessment}€` as string,
        ),
      );
    }

    callback();
  },

  candidateCode(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (value.length !== 4) callback(new Error(i18n.t('codeNotValid') as string));

    callback();
  },

  fitsCompany(_rule: unknown, value: boolean, callback: (arg0?: Error) => void): void {
    if (value === undefined) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    callback();
  },

  ibanNumber(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (!validator.isIBAN(value)) callback(new Error(i18n.t('IBANError') as string));

    callback();
  },

  swiftNumber(_rule: unknown, value: string, callback: (arg0?: Error) => void): void {
    if (!value) callback(new Error(i18n.t('aboveInputCannotBeEmpty') as string));

    if (!validator.isBIC(value)) callback(new Error(i18n.t('SWIFTError') as string));

    callback();
  },
};

export default validators;
